<template>
    <div id="room-sidePanel" class="tw-flex tw-flex-col tw-p-6">
        <!-- We may use this component later to put other features in the sidepanel -->
        <room-chat :tEvent="tEvent" :live_room_participants="live_room_participants"
                   :livekit_local_participant="livekit_local_participant"/>
    </div>
</template>

<script>
import RoomChat from './RoomChat.vue';

export default {
    name: "SidePanel",
    components: {RoomChat},
    props: {
        tEvent: {
            required: true,
            type: Object,
        },
        live_room_participants: {
            required: true,
        },
        livekit_local_participant: {
            required: true,
        },
    },
}
</script>

<style scoped>
.divider-color {
    border-color: #f0f0f0;
}

.title {
    font-size: 1rem;
    font-weight: 600;
}
</style>
